import "./bankSelectList.scss";

export default function BankSelectList({onChange, selectedValue}) {
  return (
    <div className="bankSelectList">
      <label>بانک:</label>
      <select className="selectList" onChange={(e) => onChange(e.target.value)} value={selectedValue}>
        <option value="">انتخاب بانک</option>
        <option value="اقتصاد نوین">اقتصاد نوین</option>
        <option value="ایران زمین">ایران زمین</option>
        <option value="آینده">آینده</option>
        <option value="پارسیان">پارسیان</option>
        <option value="پاسارگاد">پاسارگاد</option>
        <option value="پست بانک">پست بانک</option>
        <option value="تجارت">تجارت</option>
        <option value="توسعه تعاون">توسعه تعاون</option>
        <option value="توسعه صادرات">توسعه صادرات</option>
        <option value="خاورمیانه">خاورمیانه</option>
        <option value="دی">دی</option>
        <option value="رفاه کارگران">رفاه کارگران</option>
        <option value="سپه">سپه</option>
        <option value="سامان">سامان</option>
        <option value="سرمایه">سرمایه</option>
        <option value="سینا">سینا</option>
        <option value="شهر">شهر</option>
        <option value="صادرات">صادرات</option>
        <option value="صنعت و معدن">صنعت و معدن</option>
        <option value="کارآفرین">کارآفرین</option>
        <option value="کشاورزی">کشاورزی</option>
        <option value="گردشگری">گردشگری</option>
        <option value="مسکن">مسکن</option>
        <option value="ملت">ملت</option>
        <option value="ملی">ملی</option>
        <option value="مهر ایران">مهر ایران</option>
      </select>
    </div>
  );
}
